export default __webpack_public_path__ + "static/media/Group 3198.ad69687f.svg";